import { QueryResources } from 'datx-jsonapi-react';

import { LecturePlaylist } from '@/resources/LecturePlaylist';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

interface ILecturePlaylistFilters {
  lecture_id: string;
  playlist_id: string;
}

export const queryLecturePlaylists = (
  profileId: string,
  filters: Partial<ILecturePlaylistFilters>
): QueryResources<LecturePlaylist> => {
  return [
    LecturePlaylist.type,
    {
      filter: {
        ...omitBy({ profile_id: profileId, ...filters }, isNil),
      },
      params: [
        {
          key: 'page[size]',
          value: '100',
        },
      ],
    },
  ];
};
